import { GoogleAnalyticsService } from '@rightship-tech/common-ui/services/analytics/google-analytics.service';
import { autoinject } from "aurelia-dependency-injection";
import { VesselDetailModel } from "../../../models/vessel.models";
import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { computedFrom } from "aurelia-binding";
import { DueDiligenceApi } from "../../../apis/due-diligence.api";
import { VetStatusEnum } from "../../../models/due-diligence.models";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";

@autoinject
export class DialogSeniorApproval {
    
    private _dueDiligenceId: number;
    public vessel: VesselDetailModel;
    public message: string;
    public statusSnippet: string;
    
    constructor(private dialogClientService: DialogClientService, private dueDiligenceApi: DueDiligenceApi, 
        private notificationClientService: NotificationClientService, private googleAnalyticsService: GoogleAnalyticsService) {}

    activate(model: { dueDiligenceId: number, vessel: VesselDetailModel }) {
        this._dueDiligenceId = model.dueDiligenceId;
        this.vessel = model.vessel;
    }

    //Can save
    @computedFrom("message", "message.length", "statusSnippet", "statusSnippet.length")
    public get canSave(): boolean {
        return this.message && this.message.length > 0 && this.statusSnippet && this.statusSnippet.length > 0;
    }

    //Reuqest senior approval
    public async requestSeniorApproval() {
        if (!this.canSave) {
            return;
        }

        //Change status to 'Awaiting Senior Approval'
        try {
            await this.dueDiligenceApi.changeStatus(this._dueDiligenceId, this.message, this.statusSnippet, VetStatusEnum.DD_PendingSeniorApproval);
            this.notificationClientService.show("Senior approval successfully requested", "", NotificationType.Success);

            //Send event to google analytics
            this.googleAnalyticsService.sendCustomGA4EventMulti("ddh_senior_approval_submit", {
                "vesselName": this.vessel.name ?? "N/a",
                "vesselImo": this.vessel.internationalMaritimeOrganizationNumber ?? "N/a",
                "vesselType": this.vessel.vesselType ?? "N/a"
            });

            //Close dialog
            this.close();
        } 
        catch (error) {
            console.error("An error occurred while changing status", error);
            this.notificationClientService.show("An error occurred while changing status", "", NotificationType.Error);
        }
    }

    //Close dialog
    public close() {
        this.dialogClientService.hide();
    }
}